import { Close, Search } from '@mint-lib/icons';

import { Button } from '../../lib/button.jsx';
import { Divider } from '../../lib/divider.jsx';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '../../lib/input-group.jsx';
import { InputProps } from '../../lib/input.jsx';

function SearchBar({
  className,
  type,
  size,
  disabled = false,
  searchButton = false,
  onClear,
  onSearch,
  ...props
}: InputProps & {
  searchButton?: boolean;
  onClear?: () => void;
  onSearch?: () => void;
}) {
  return (
    <InputGroup size={size} className={className}>
      <InputGroupInput disabled={disabled} readOnly={false} {...props} />
      {!searchButton && (
        <InputGroupAddon>
          <Search />
        </InputGroupAddon>
      )}
      {props.value && (
        <InputGroupAddon align="inline-end">
          <Button
            icon
            size="small"
            variant="text"
            onClick={onClear}
            aria-label="clear-button"
            data-dd-action-name="clear search"
          >
            <Close />
          </Button>
          {searchButton && (
            <div className={'m-0 ml-1 h-6'}>
              <Divider orientation="vertical" color="light" />
            </div>
          )}
        </InputGroupAddon>
      )}

      {searchButton && (
        <InputGroupAddon align="inline-end">
          <Button
            aria-label="search-button"
            data-dd-action-name="search"
            icon
            size="small"
            variant="text"
            disabled={disabled}
            onClick={onSearch}
          >
            <Search />
          </Button>
        </InputGroupAddon>
      )}
    </InputGroup>
  );
}

export default SearchBar;
